import { SET_DEVICE_INFO, CLEAR_DEVICE_INFO } from "../types";

export const setDeviceInfoRedux = (data) => ({
    type: SET_DEVICE_INFO,
    payload: data,
});

export const clearDeviceInfo = () => ({
    type: CLEAR_DEVICE_INFO,
});
